import {
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  Step1Actions,
  Step1BillingAddressData,
  Step1BillingGeneralData,
  Step1BillingOwnerData,
  Step1PaymentAccountData,
  Step1PaymentContactData,
} from '@/AutoEnrollment/ui/atoms'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step1Form } from '@/AutoEnrollment/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const AutoEnrollmentStep1 = (): JSX.Element => {
  const { t } = useTranslation()
  const { getCurrentStepForm } = useAutoEnrollment()

  const form = getCurrentStepForm() as UseFormReturn<Step1Form>

  return (
    <FormProvider {...form}>
      <form>
        <OreStack placeContent="stretch" space="large">
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack placeContent="stretch" space="xlarge">
                <Step1BillingGeneralData />
                <Step1PaymentAccountData />
                <Step1BillingAddressData />
                <Step1BillingOwnerData />
                <Step1PaymentContactData />
                <OreText>{t(formTranslation.common.requiredFields)}</OreText>
              </OreStack>
            </OreCardWrapper>
            <OreCardActions>
              <Step1Actions />
            </OreCardActions>
          </OreCardContainer>
        </OreStack>
      </form>
    </FormProvider>
  )
}
